import { useTranslation } from "react-i18next";
import LandingHeader from "@/components/landing/LandingHeader";
import LandingFooter from "@/components/landing/LandingFooter";

const Privacy = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-background flex flex-col">
      <LandingHeader />
      
      <main className="flex-1 py-16 px-4">
        <div className="max-w-3xl mx-auto prose prose-neutral dark:prose-invert">
          <h1 className="text-3xl font-bold mb-8">{t("legal.privacy.title")}</h1>
          
          <p className="text-muted-foreground mb-8">
            {t("legal.privacy.lastUpdated")}: 2025-12-30
          </p>

          <section className="mb-8">
            <h2 className="text-xl font-semibold mb-4">{t("legal.privacy.sections.intro.title")}</h2>
            <p className="text-muted-foreground">{t("legal.privacy.sections.intro.content")}</p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold mb-4">{t("legal.privacy.sections.dataCollection.title")}</h2>
            <p className="text-muted-foreground">{t("legal.privacy.sections.dataCollection.content")}</p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold mb-4">{t("legal.privacy.sections.usage.title")}</h2>
            <p className="text-muted-foreground">{t("legal.privacy.sections.usage.content")}</p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold mb-4">{t("legal.privacy.sections.storage.title")}</h2>
            <p className="text-muted-foreground">{t("legal.privacy.sections.storage.content")}</p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold mb-4">{t("legal.privacy.sections.thirdParty.title")}</h2>
            <p className="text-muted-foreground">{t("legal.privacy.sections.thirdParty.content")}</p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold mb-4">{t("legal.privacy.sections.userRights.title")}</h2>
            <p className="text-muted-foreground">{t("legal.privacy.sections.userRights.content")}</p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold mb-4">{t("legal.privacy.sections.cookies.title")}</h2>
            <p className="text-muted-foreground">{t("legal.privacy.sections.cookies.content")}</p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold mb-4">{t("legal.privacy.sections.contact.title")}</h2>
            <p className="text-muted-foreground">{t("legal.privacy.sections.contact.content")}</p>
          </section>
        </div>
      </main>

      <LandingFooter />
    </div>
  );
};

export default Privacy;
